import React from "react"

import useScreenLoading from "@/store/screenLoading"

import "./style.less"

const _404: React.FC = () => {
    const setScreenLoading = useScreenLoading(s => s.setScreenLoading)

    React.useEffect(() => {
        setScreenLoading(false)
    }, [])

    return (
        <div className="_404">
            <img
                className="_404-img"
                src={require("@/assets/404.png")} />
            <div className="_404-text">The order address is wrong</div>
        </div>
    )
}

export default _404
